import { faAngleRight, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

type Props = {
  name: string;
  chapterKey: string;
  moduleKey: string;
  firstPageKey: string;
  description: string;
  length: number;
  isCompleted: boolean;
  color: string;
  beginChapter: (moduleKey: string, key: string) => void;
  isFacilitator: boolean;
};

const Chapter = ({
  moduleKey,
  attributes,
  beginChapter,
  isActive,
  isFacilitator,
}: any) => {
  const { name, key, description, length, isCompleted, isLocked, color } =
    attributes;
  const btnClass = isActive
    ? "btn btn-sm btn-primary fs-6 px-3 py-1 fw-bolder"
    : "btn btn-sm btn-secondary fs-6 px-3 py-1 fw-bold";
  const btnText = attributes.activePage
    ? "Resume"
    : isCompleted
    ? "Redo"
    : "Start";

  return (
    <div className="d-flex flex-row-fluid flex-center border-bottom pb-3 pt-3 chapter-item">
      <div
        className="ms-2 me-3 align-self-stretch"
        style={{
          background: isCompleted ? color : "#d4d4d4",
          borderRadius: "2px",
          minWidth: "4px",
          minHeight: "39px",
        }}
      ></div>
      <div className="flex-grow-1">
        {/* Name and Length */}
        <div className="d-flex flex-row gap-2 align-items-center">
          <div className={`fw-bolder ${isLocked && "text-gray-600"}`}>
            {name}
          </div>
        </div>
        {/* Description */}
        <div className={`${isLocked && "text-gray-600"} fs-7`}>
          {description}
        </div>
      </div>
      {!isLocked && isFacilitator && (
        <div className="ms-1 me-2">
          {!isActive && (
            <FontAwesomeIcon
              className={clsx("fs-6", "show-when-not-hovered")}
              style={{ color: isCompleted ? "green" : "#d4d4d4" }}
              icon={isCompleted ? faCheck : faAngleRight}
            />
          )}
          <button
            className={clsx(btnClass, !isActive && "show-when-hovered")}
            onClick={() => beginChapter(moduleKey, key)}
          >
            {btnText}
          </button>
        </div>
      )}
    </div>
  );
};

export default Chapter;
